import React from 'react'
import empty from '../../assets/images/OBJECTS.png'

export default function NotFound({ paragraphText }) {
  return (
    <div className=" d-flex flex-column align-items-center my-5">
      <img src={empty} alt="" />
      <h4 className=' my-4 w-75 text-center text-muted'>
        {paragraphText}
      </h4>
    </div>
  );
}
